/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface UpdateScriptSectionRequest
 */
export interface UpdateScriptSectionRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateScriptSectionRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateScriptSectionRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateScriptSectionRequest
     */
    order?: number;
}

/**
 * Check if a given object implements the UpdateScriptSectionRequest interface.
 */
export function instanceOfUpdateScriptSectionRequest(value: object): boolean {
    return true;
}

export function UpdateScriptSectionRequestFromJSON(json: any): UpdateScriptSectionRequest {
    return UpdateScriptSectionRequestFromJSONTyped(json, false);
}

export function UpdateScriptSectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateScriptSectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'order': json['order'] == null ? undefined : json['order'],
    };
}

export function UpdateScriptSectionRequestToJSON(value?: UpdateScriptSectionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'description': value['description'],
        'order': value['order'],
    };
}

